import type { FC } from "react";
import { useState } from "react";
import { Button } from "@mui/material";
import { migrateCustomersToExternalCrm } from "./externalCrmApi";

const ExternalCrmMigration: FC = () => {
  const [running, setRunning] = useState(false);
  const [log, setLog] = useState("");

  async function handleMigrate() {
    if (!confirm("Wysłać wszystkich klientów i osoby kontaktowe do zewnętrznego CRM?")) {
      return;
    }
    setRunning(true);
    setLog("Synchronizuję...");
    try {
      const result = await migrateCustomersToExternalCrm();
      setLog(
        [
          `Firmy: ${result.companies}`,
          `Osoby kontaktowe: ${result.contactPersons}`,
          `Import w toku, ID procesów: ${result.processIds.join(", ") || "-"}`,
        ].join("\n"),
      );
    } catch (error) {
      setLog(`Błąd: ${error instanceof Error ? error.message : String(error)}`);
    } finally {
      setRunning(false);
    }
  }

  return (
    <div>
      <h1>Zewnętrzny CRM</h1>
      <Button variant="contained" onClick={handleMigrate} disabled={running}>
        Synchronizuj wszystkich klientów z CRM
      </Button>
      {log && <pre style={{ background: "#f5f5f5", padding: "1rem", border: "1px solid #ccc" }}>{log}</pre>}
    </div>
  );
};

export default ExternalCrmMigration;
